// StepSourceLanguage.tsx
import React, {Dispatch, SetStateAction} from "react";
import {
  Checkbox,
  Flex,
} from "@chakra-ui/react";
import LanguageInput from "./LanguageInput.tsx";
import LanguageConfiguration from "./LanguageConfiguration.tsx";
import {ILanguageConfiguration} from "../../models/interfaces/languageConfiguration.interface.ts";
import LanguageDefaultConfiguration from "../LanguageDefaultConfigurationIcon.tsx";

interface StepSourceLanguageProps {
  sourceLanguages: string[];
  selectedSourceLang: string;
  config: Partial<ILanguageConfiguration>;
  onSelect: (lang: string) => void;
  onUpdateConfig: (config: Partial<ILanguageConfiguration>) => void;
  transcribeOnly?: boolean;
  toggleIsTranscribeOnly: () => void;
}

const StepSourceLanguage: React.FC<StepSourceLanguageProps> = (
  {
    sourceLanguages,
    selectedSourceLang,
    config,
    onSelect,
    onUpdateConfig,
    transcribeOnly,
    toggleIsTranscribeOnly,
  }: StepSourceLanguageProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [inputValue, setInputValue] = React.useState(selectedSourceLang);

  return (
    <Flex className="flex-col gap-2">
      {/* Dropdown for Source Language */}
      <LanguageInput
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        languages={sourceLanguages}
        selectedLanguage={inputValue}
        onSelectLanguage={(lang: string) => {
          setInputValue(lang);
          onSelect(lang);
        }}
        onChange={(value) => setInputValue(value)}
        placeholder="Select source language"
      />
      <LanguageDefaultConfiguration
        lang={selectedSourceLang}
        currentConfig={config}
        updateConfig={onUpdateConfig}
      />

      {/* Source Configuration */}
      <LanguageConfiguration
        config={config}
        setConfig={onUpdateConfig}
        isDisabled={selectedSourceLang === ""}
      />

      <Checkbox
        mt={2}
        colorScheme="brandPurple"
        color="white"
        isChecked={transcribeOnly}
        onChange={(event) => toggleIsTranscribeOnly()}
      >
        Transcribe only
      </Checkbox>
    </Flex>
  );
};

export default StepSourceLanguage;